import { render } from "./CatalogueListHeader.vue?vue&type=template&id=f661d912"
import script from "./CatalogueListHeader.vue?vue&type=script&lang=js"
export * from "./CatalogueListHeader.vue?vue&type=script&lang=js"
script.render = render

export default script